/**
 * aswbe checkin eapi
 * チェックイン業務で利用するAPIを提供する
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 座席指定可否情報
 */
export interface PostJourneysGetJourneyResponseDataSeatmapEligibility {
  /**
   * 座席指定可否ステータス<br> DxAPIから取得した、国際線のNHグループ運航便、および国内線のNHグループ運航便またはNHグループ販売便に紐づくjourneyElement/seatmapEligibility/statusに1件でも\"eligible\"が存在する場合に座席指定可とする<br> eligible: 座席指定可<br> ineligible: 座席指定不可
   */
  status: PostJourneysGetJourneyResponseDataSeatmapEligibility.StatusEnum;
}
export namespace PostJourneysGetJourneyResponseDataSeatmapEligibility {
  export type StatusEnum = 'eligible' | 'ineligible';
  export const StatusEnum = {
    Eligible: 'eligible' as StatusEnum,
    Ineligible: 'ineligible' as StatusEnum,
  };
}
